import React from 'react';
import VendorTypeList from './VendorTypeList';

const VendorTypes = () => {
  return <VendorTypeList />;
};

export default VendorTypes;
